import React from "react";
import CategoryPage from "./CategoryPage";

const CustomizedKeychains = () => (
  <CategoryPage
    categoryId="customized-keychains"
    categoryTitle="Customized Keychains"
    categoryDescription="Create personalized keychains with custom names, logos, or designs. Durable materials, vibrant colors, and compact design. Perfect for gifts or personal use."
  />
);

export default CustomizedKeychains;
